import { useNuxtApp } from '#app'

/**
 * This middleware fetches highlighted blog post summaries and makes them
 * available in the saasLayout store.
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()

  const store = nuxtApp.$store

  // Check if store and saasLayout module are available
  if (!store || !store.hasModule('saasLayout')) {
    return
  }

  if (!store.getters['saasLayout/isLoaded']) {
    try {
      await store.dispatch('saasLayout/fetchAll')
    } catch (error) {
      console.error('Failed to fetch saasLayout data:', error)
    }
  }
})
